import { Box } from '@mui/material';

const CreateMoreBtn = ({ notification, createMoreBtnTitle, onCreate, onClose }) => {

    // --- Styles extracted into variables ---
    const containerStyle = {
        p: 4,
        width: '100%',
        minHeight: 300,
    };

    const titleStyle = {
        fontSize: { xs: '2rem', sm: '2.5rem' },
        fontWeight: 700,
        color: 'primary.main',
        mb: 4,
        textAlign: 'center',
        letterSpacing: 1,
    };

    const actionsContainerStyle = {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-end',
        alignItems: 'center',
        width: '100%',
        position: 'absolute',
        bottom: 32,
        left: 0,
        px: 4,
        gap: 2,
    };

    const primaryButtonStyle = {
        width: 200,
        padding: '12px 0',
        borderRadius: 8,
        border: 'none',
        background: '#1976d2',
        color: '#fff',
        fontWeight: 400,
        fontSize: '1.1rem',
        cursor: 'pointer',
        boxShadow: '0 2px 8px rgba(25, 118, 210, 0.15)',
        transition: 'background 0.2s',
        marginRight: 5,
    };

  const secondaryButtonStyle = {
  width: 200,
  padding: "12px 0",
  borderRadius: 8,
  border: "1px solid #ccc",
  background: "#f5f5f5",
  color: "#333",
  fontWeight: 500,
  fontSize: "1.1rem",
  cursor: "pointer",
  boxShadow: "0 2px 6px rgba(0, 0, 0, 0.08)",
  transition: "background 0.2s",
};

    return (
        <Box display="flex" flexDirection="column" sx={containerStyle}>
            <Box component="span" sx={titleStyle}>
                {notification}
            </Box>
            <Box sx={actionsContainerStyle}>
                <button style={secondaryButtonStyle} onClick={onClose}>
                    Close
                </button>
                <button style={primaryButtonStyle} onClick={onCreate}>
                    {createMoreBtnTitle}
                </button>

            </Box>
        </Box>
    );
};

export default CreateMoreBtn;
